import PrebuiltBetBuilder from './_prebuilt-bet-builder.js'
import PrebuiltAcca from './_prebuilt-acca.js'

export default {
  name: 'PrebuiltBetController',
  values: {
    prebuiltBetBuilder: {
      configSet: PrebuiltBetBuilder,
      configValues: {
        view: {
          cardClickable: true,
        },
      },
    },
    prebuiltAcca: {
      configSet: PrebuiltAcca,
      configValues: {
        view: {
          showBackgroundSportImage: false,
          cardClickable: false,
        },
      },
    },
  },
  meta: {
    extendable: false,
  },
}
